export default __webpack_public_path__ + "static/media/458.db5e61d4.gif";